import { MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Canonical "you need a location to list" warning — extracted from
 * QuickListPopover so ItemFormModal and QuickPriceEditDialog can drop
 * their bespoke variants (which previously used a blocking toast).
 *
 * Renders nothing until the caller confirms the profile has loaded AND
 * location is missing — avoids flashing during hydration.
 */
export function ListingLocationWarning({
  profileLoaded,
  hasLocation,
}: {
  profileLoaded: boolean;
  hasLocation: boolean;
}) {
  if (!profileLoaded || hasLocation) return null;
  return (
    <div
      role="alert"
      className="rounded-lg border border-warning/30 bg-warning/10 p-2 text-[11px] text-warning leading-snug"
    >
      <MapPin className="inline w-3 h-3 mr-1 -mt-0.5" />
      <Link to="/settings" className="underline hover:text-warning">
        Set your location
      </Link>{' '}
      in Profile to list items.
    </div>
  );
}
